import React, { useEffect } from 'react';
import CountDown from '../components/CountDown';
import Header from '../components/Header/Header';
import side from '../assets/side.png';
import BottomMain from '../components/BottomMain';
import HTPCard from '../components/HTPCard';
import WinningCriteria from '../components/WinningCriteria';
import FAQs from '../components/FAQs';
import Distribution from '../components/Distribution';
import Footer from '../components/Footer/Footer';
import GYTN from '../components/GYTN';
import FRHistory from '../components/FRHistory';
import VideoSection from '../components/VideoSection';
import CarouselBanner from '../components/CarouselBanner';
import BugBounty from '../components/BugBounty/BugBounty';
import BuyTicketSection from '../components/BuyTicketSection';
import ModalBuyTicket from '../components/ModalBuyTicket';
import ModalDrawPick from '../components/ModalDrawPick';
import NotificationAlert from '../components/NotificationAlert';
import { useSelector } from 'react-redux';
import axios from '../utils/axios';
import { notifyError } from '../utils/toastError';
import MarketingComp from '../components/MarketingComp';
import MarginBottom from '../components/MarginBottom';
import { getFaqs } from '../Services/Faq';
import { getMarketingFaqs } from '../Services/MarketingFaq';

const Home = () => {
  const [showModal, setShowModal] = React.useState(false);
  const [showModalDrawPick, setShowModalDrawPick] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const [day, setDay] = React.useState(false); // true=friday, false=tuesday
  const { friday, tuesday, both, fridayTime, tuesdayTime } = useSelector(state => state.lotteryDay);
  const { lotteryContract, tuesdayContract } = useSelector(
    state => state.provider
  );
  const [faqs, setFaqs] = React.useState([]);



  const getNotifications = async () => {
    try {
      const response = await axios.get(
        'api/notification/fetchallnotification'
      );
      const data = await response.data;
      if (data.success) {
        setNotifications(data.notification);
      } else {
        notifyError("Error getting notifications");
      }


    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    fetchFaq();
  }, []);

  const fetchFaq = async () => {
    const resp = await getFaqs();
    if (resp.data.success) {
      setFaqs(resp.data.data);
    } else {
      console.log("Error to fetch faqs");
    }
  }



  return (
    <div>
      <div className="absolute top-0 left-0 w-screen bg-black/80 rounded-xl z-50">
        <div className="flex justify-center items-center flex-col">
          {notifications
            ? notifications.map(notification => (
              <NotificationAlert key={notification._id} {...notification} />
            ))
            : null}
        </div>
      </div>

      <ModalBuyTicket
        setShowModal={setShowModal}
        showModal={showModal}
        setShowModalDrawPick={setShowModalDrawPick}
      />
      <ModalDrawPick
        showModalDrawPick={showModalDrawPick}
        setShowModalDrawPick={setShowModalDrawPick}
      />
      <div className="w-full min-h-screen flex flex-col">
        <Header />
        <div className="flex justify-evenly flex-col md:flex-row py-12">
          <div className="space-y-10 text-white">
            <h1 className="text-[4em] sm:text-[5em] text-center">
              Grab A <span className="text-lyellow">Bag</span>
            </h1>

            {both
              ? <div>
                {(parseInt(tuesdayTime) < parseInt(fridayTime)) ?
                  <>
                    <h2 className="text-center text-2xl md:text-4xl text-lyellow mb-8">
                      Next Tuesday Lottery Prize In
                    </h2>

                    <CountDown lotteryContract={tuesdayContract} />
                  </>
                  :
                  <>
                    <h2 className="text-center text-2xl md:text-4xl text-lyellow my-8">
                      Next Friday Lottery Prize In
                    </h2>
                    <CountDown lotteryContract={lotteryContract} />
                  </>
                }
              </div>
              : tuesday
                ? <div>
                  <h2 className="text-center text-2xl md:text-4xl text-lyellow mb-8">
                    Next Tuesday Lottery Prize In
                  </h2>
                  <CountDown lotteryContract={tuesdayContract} />
                </div>
                : <div>
                  <h2 className="text-center text-2x; md:text-4xl text-lyellow mb-8">
                    Next Friday Lottery Prize In
                  </h2>
                  <CountDown lotteryContract={lotteryContract} />
                </div>}
            
              <div className="flex justify-center items-center">
                <button
                  className="bg-lyellow text-md font-semibold py-3 px-[5em] hover:bg-[#1d2226] hover:text-white transition ease-in duration-200 rounded-xl"
                  onClick={() => setShowModal(true)}
                >
                  Buy Ticket
                </button>
              </div> 
          </div>
          <img
            src={side}
            alt="side"
            className="hover:animate-pulse cursor-pointer lg:flex pt-5 sm:pt-0"
          />
        </div>
        {/* <BottomMain /> */}
      </div>
      <div className='relative bottom-8'>

        <MarginBottom />
      </div>

      <BuyTicketSection setShowModal={setShowModal} />

      <GYTN setShowModal={setShowModal} />

      <FRHistory />

      <CarouselBanner />
      <HTPCard />

      <VideoSection />

      <WinningCriteria />

      <Distribution />
      <MarketingComp />
      <BugBounty />
      {faqs.length > 0 ?
        <FAQs faqs={faqs} />
        : null}


      <Footer />
    </div>
  );
};

export default Home;
